import User from '@/assets/images/user.svg'
import IconCard from '@/components/UI/IconCard'
import { useScreenOrientation, useScreenSize } from '@/hooks/screen'
import { FC, ReactNode } from 'react'

interface CurrentProfileCardProps {
    name: string
    description?: string
    onPress?: () => void
    RightContent?: ReactNode
}

const CurrentProfileCard: FC<CurrentProfileCardProps> = ({
    name,
    description,
    onPress,
    RightContent,
}) => {
    const screenSize = useScreenSize()
    const screenOrientation = useScreenOrientation()

    const marginTop = screenSize === 'small' && screenOrientation === 'landscape' ? 8 : 32

    return (
        <IconCard
            rounded
            title={name}
            subtitle={description}
            Icon={User}
            onPress={onPress}
            RightContent={RightContent}
            style={{ marginTop }}
        />
    )
}

export default CurrentProfileCard
